import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email });
      toast.success(data.message || "Subscribed");
      setDone(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not subscribe");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="brutal-border-red bg-[#0a0a0a] p-6" data-testid="newsletter-success">
        <div className="font-jp text-2xl text-[#FF3333]">規律</div>
        <div className="font-heading uppercase text-xl mt-2">You're in.</div>
        <div className="font-sub text-white/60 text-sm mt-1">
          Weekly drops — training, anime, new shows, and Forged releases — hit your inbox every Monday.
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="brutal-border bg-[#0a0a0a] p-6" data-testid="newsletter-form">
      <div className="flex items-center gap-2 mb-3">
        <Mail className="w-4 h-4 text-[#FF3333]" />
        <div className="font-mono text-[10px] tracking-[0.3em] text-[#FF3333]">JOIN THE FORGE</div>
      </div>
      <div className="font-heading uppercase text-2xl leading-tight">
        Weekly drops, <br /><span className="text-stroke-red">straight to your inbox.</span>
      </div>
      <div className="font-sub text-white/50 text-sm mt-2">
        Workout tips, supplement intel, anime &amp; nerd news, plus first dibs on Waifu Collection releases.
      </div>
      <div className="mt-5 flex gap-2 flex-wrap">
        <input
          type="email"
          required
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="newsletter-email-input"
          className="flex-1 min-w-[200px] bg-transparent border border-white/15 focus:border-[#FF3333] outline-none px-4 py-3 font-sub text-base transition-colors"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit"
          className="btn-forged-red disabled:opacity-50"
        >
          {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> ...</> : "Subscribe"}
        </button>
      </div>
      <div className="font-mono text-[9px] tracking-widest text-white/30 mt-3">
        ONE DROP PER WEEK · UNSUBSCRIBE ANYTIME
      </div>
    </form>
  );
}
